import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptor {

  constructor(private authService: AuthService) { }

  /**
   * This method intercepts all http requests and adds the token to the headers
   * @returns Observable<HttpEvent<unknown>>
   * @param request
   * @param next
   * @returns
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let authHeader = request.headers.get('Authorization');
    // If the request already has an authorization header, do nothing
    if (authHeader) return next.handle(request);
    // Add the token to the headers
    let additionalHeaders: any = {};
    // If the token exists, add it to the headers
    if (this.authService.token) {
      additionalHeaders['Authorization'] = `token ${this.authService.token}`;
    }
    console.debug("HttpInterceptor", additionalHeaders);
    return next.handle(request.clone({ setHeaders: additionalHeaders }))
  }
}
